/* Copypark Bauplan-Konfigurator v1.3 */
(function(){
"use strict";

function boot(){
  document.querySelectorAll("[data-cpc-root]").forEach(init);
}

function waitForPdfJs(callback, tries){
  if(window.pdfjsLib){ callback(); return; }
  if(tries <= 0){ console.error("[CPC] PDF.js konnte nicht geladen werden."); return; }
  setTimeout(function(){ waitForPdfJs(callback, tries - 1); }, 100);
}

function init(root){
  if(root.dataset.cpcReady === "1") return;
  root.dataset.cpcReady = "1";

  waitForPdfJs(function(){ start(root); }, 100);
}

function start(root){
  const PRICES={
    paper90:{A4:.55,A3:1.60,A2:3.20,A1:6.40,A0:10.30,CUSTOM:15},
    synthetic:{A4:1.10,A3:3.20,A2:6.40,A1:12.80,A0:20.60,CUSTOM:30},
    fold:{A3:.20,A2:.30,A1:.40,A0:.60,LARGE:.80},
    punch:.20,express:5,
    discounts:[{min:500,rate:.20},{min:250,rate:.15},{min:100,rate:.10},{min:50,rate:.05}],
    expressTiers:[{max:50,fee:5},{max:150,fee:10},{max:300,fee:20},{max:Infinity,fee:30}]
  };
  const FORMATS={A4:[210,297],A3:[297,420],A2:[420,594],A1:[594,841],A0:[841,1189]};
  const MAX_FILES=5, TOLERANCE=2, MAX_SHORT=914, MAX_LONG=3200;
  let items=[], uid=0, modalIndex=0, modalPdf=null, modalPage=null;
  let zoom=1, ox=0, oy=0, dragging=false, dragStart=null;
  const pdfSources=new Map();

  const q=s=>root.querySelector(s), qa=s=>Array.from(root.querySelectorAll(s));
  const el={
    input:q("[data-cpc-input]"),drop:q("[data-cpc-drop]"),status:q("[data-cpc-status]"),
    progress:q("[data-cpc-progress]"),progressBar:q("[data-cpc-progress-bar]"),progressText:q("[data-cpc-progress-text]"),
    pages:q("[data-cpc-pages]"),summary:q("[data-cpc-summary]"),selectAll:q("[data-cpc-select-all]"),
    copy:q("[data-cpc-copy]"),reset:q("[data-cpc-reset]"),cart:q("[data-cpc-cart]"),
    production:qa("[data-cpc-production]"),productionCards:qa("[data-cpc-production-card]"),
    bottomTotal:q("[data-cpc-bottom-total]"),totalPages:q("[data-cpc-total-pages]"),bottomPickup:q("[data-cpc-bottom-pickup]"),
    modal:q("[data-cpc-modal]"),modalCanvas:q("[data-cpc-modal-canvas]"),modalInfo:q("[data-cpc-modal-info]"),
    modalPrev:q("[data-cpc-modal-prev]"),modalNext:q("[data-cpc-modal-next]"),zoomStage:q("[data-cpc-zoom-stage]"),
    zoomIn:q("[data-cpc-zoom-in]"),zoomOut:q("[data-cpc-zoom-out]"),zoomFit:q("[data-cpc-zoom-fit]"),zoomLabel:q("[data-cpc-zoom-label]"),
    materialModal:q("[data-cpc-material-modal]")
  };

  if(!el.input || !el.drop){ console.error("[CPC] Upload-Feld fehlt."); return; }

  pdfjsLib.GlobalWorkerOptions.workerSrc="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

  const euro=v=>new Intl.NumberFormat("de-DE",{style:"currency",currency:"EUR"}).format(v);
  const round=(v,d=2)=>Math.round((v+Number.EPSILON)*Math.pow(10,d))/Math.pow(10,d);
  const esc=s=>String(s).replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[c]));
  const sorted=(w,h)=>w<=h?[w,h]:[h,w];

  function status(text,type){ el.status.textContent=text; el.status.className="cpc__status"+(type?" is-"+type:""); }
  function progress(done,total,text){ el.progress.hidden=false; el.progressBar.style.width=Math.max(4,Math.min(100,total?done/total*100:5))+"%"; el.progressText.textContent=text; }
  function hideProgress(){ el.progressBar.style.width="100%"; setTimeout(()=>{el.progress.hidden=true;el.progressBar.style.width="0%";},350); }
  function detect(w,h){ const [a,b]=sorted(w,h); for(const [name,[fw,fh]] of Object.entries(FORMATS)){if(Math.abs(a-fw)<=TOLERANCE&&Math.abs(b-fh)<=TOLERANCE)return name;} return "CUSTOM"; }
  function maxScaleFor(x){
    const longScale=Math.min(MAX_LONG/x.ow,MAX_LONG/x.oh);
    const shortScale=MAX_SHORT/Math.min(x.ow,x.oh);
    return Math.max(.0001,Math.min(longScale,shortScale));
  }
  function proportionalSize(x,scale){
    const safe=Math.max(.0001,Math.min(Number(scale)||.0001,maxScaleFor(x)));
    return [round(x.ow*safe,1),round(x.oh*safe,1),safe];
  }
  function minScaleForA4(x){
    const portrait=x.oh>=x.ow;
    const targetW=portrait?210:297;
    const targetH=portrait?297:210;
    return Math.max(targetW/x.ow,targetH/x.oh);
  }
  function boundedProportionalSize(x,scale){
    const minScale=Math.min(minScaleForA4(x),maxScaleFor(x));
    const safe=Math.max(minScale,Math.min(Number(scale)||minScale,maxScaleFor(x)));
    return [round(x.ow*safe,1),round(x.oh*safe,1),safe];
  }
  function dims(x){
    if(x.target==="ORIGINAL")return[x.ow,x.oh];
    if(x.target==="CUSTOM")return[x.cw,x.ch];
    const [a,b]=FORMATS[x.target]; return x.ow>x.oh?[b,a]:[a,b];
  }
  function effective(x){ return x.target==="ORIGINAL"?x.originalFormat:x.target; }
  function printPrice(x){ const f=effective(x); let base; if(f==="CUSTOM"){const[w,h]=dims(x);base=w*h/1e6*PRICES[x.material].CUSTOM;}else base=PRICES[x.material][f]; return base*x.qty; }
  function foldPrice(x){ const f=effective(x); if(f==="A4")return 0;if(PRICES.fold[f]!==undefined)return PRICES.fold[f]*x.qty;const[w,h]=dims(x);return(w*h>FORMATS.A0[0]*FORMATS.A0[1]?PRICES.fold.LARGE:PRICES.fold.A0)*x.qty; }
  function itemTotal(x){let t=printPrice(x);if(x.material==="paper90"){if(x.finish==="folded")t+=foldPrice(x);if(x.punch)t+=PRICES.punch*x.qty;}return round(t,2);}

  function discountFor(subtotal){
    const tier=PRICES.discounts.find(t=>subtotal>=t.min);
    return tier||{min:0,rate:0};
  }
  function nextDiscountFor(subtotal){
    const ascending=[...PRICES.discounts].sort((a,b)=>a.min-b.min);
    return ascending.find(t=>subtotal<t.min)||null;
  }
  function expressFeeFor(subtotal){
    return PRICES.expressTiers.find(t=>subtotal<=t.max).fee;
  }
  function orderTotals(){
    const print=items.reduce((s,x)=>s+printPrice(x),0);
    const fold=items.reduce((s,x)=>s+(x.material==="paper90"&&x.finish==="folded"?foldPrice(x):0),0);
    const punch=items.reduce((s,x)=>s+(x.material==="paper90"&&x.punch?PRICES.punch*x.qty:0),0);
    const subtotal=round(print+fold+punch,2);
    const discountTier=discountFor(subtotal);
    const discount=round(subtotal*discountTier.rate,2);
    const production=(el.production.find(r=>r.checked)||{}).value||"standard";
    const express=production==="express"?expressFeeFor(subtotal):0;
    const total=round(subtotal-discount+express,2);
    return {print:round(print,2),fold:round(fold,2),punch:round(punch,2),subtotal,discountRate:discountTier.rate,discount,production,express,total};
  }
  function compactPages(){
    return items.map(x=>{
      const [w,h]=dims(x);
      return {
        file:x.file,page:x.page,originalWidthMm:x.ow,originalHeightMm:x.oh,
        outputWidthMm:round(w,1),outputHeightMm:round(h,1),
        outputFormat:effective(x),material:x.material,finish:x.finish,
        punch:x.punch,quantity:x.qty,price:itemTotal(x)
      };
    });
  }


  async function loadFiles(fileList){
    const files=Array.from(fileList).slice(0,MAX_FILES);
    if(!files.length)return;
    status("PDF-Dateien werden analysiert …");
    progress(0,1,"Dateien werden vorbereitet …");

    const jobs=[]; let total=0;
    for(const file of files){
      if(!(file.type==="application/pdf"||file.name.toLowerCase().endsWith(".pdf"))){status(file.name+" ist keine PDF-Datei.","error");continue;}
      const bytes=new Uint8Array(await file.arrayBuffer());
      const sourceId="s"+Date.now()+"-"+(++uid);
      pdfSources.set(sourceId,{bytes:bytes.slice(),name:file.name,type:file.type||"application/pdf"});
      const pdf=await pdfjsLib.getDocument({data:bytes}).promise;
      total+=pdf.numPages; jobs.push({file,pdf,sourceId});
    }

    let done=0;
    for(const job of jobs){
      for(let n=1;n<=job.pdf.numPages;n++){
        const page=await job.pdf.getPage(n), vp=page.getViewport({scale:1});
        const ow=round(vp.width*25.4/72,1), oh=round(vp.height*25.4/72,1);
        const tvp=page.getViewport({scale:170/vp.width});
        const canvas=document.createElement("canvas");
        canvas.width=Math.ceil(tvp.width);canvas.height=Math.ceil(tvp.height);
        await page.render({canvasContext:canvas.getContext("2d"),viewport:tvp}).promise;
        const originalFormat=detect(ow,oh);
        const tempItem={ow,oh};
        const minScale=minScaleForA4(tempItem);
        const belowA4=minScale>1.0001;
        const initial=belowA4?boundedProportionalSize(tempItem,minScale):[ow,oh,1];
        items.push({id:"p"+(++uid),sourceId:job.sourceId,sourcePage:n,file:job.file.name,page:n,thumb:canvas.toDataURL("image/jpeg",.78),ow,oh,originalFormat,target:belowA4?"CUSTOM":"ORIGINAL",cw:initial[0],ch:initial[1],keep:true,material:"paper90",finish:"rolled",punch:false,qty:1,selected:false});
        page.cleanup();done++;progress(done,total,"Seite "+done+" von "+total+" wird analysiert …");
      }
      await job.pdf.destroy();
    }
    render();hideProgress();const autoCount=items.filter(i=>i.target==="CUSTOM"&&i.cw>=210&&i.ch>=210&&i.originalFormat==="CUSTOM"&&(i.ow<210||i.oh<210)).length;status(items.length+" Seite"+(items.length===1?"":"n")+" erkannt."+(autoCount?" "+autoCount+" Seite"+(autoCount===1?" wurde":"n wurden")+" automatisch auf mindestens DIN A4 skaliert.":""),"success");
  }

  function targetOptions(x){return[["ORIGINAL","Original ("+(x.originalFormat==="CUSTOM"?"Sonderformat":"DIN "+x.originalFormat)+")"],["A4","DIN A4"],["A3","DIN A3"],["A2","DIN A2"],["A1","DIN A1"],["A0","DIN A0"],["CUSTOM","Benutzerdefinierte Größe"]].map(([v,t])=>`<option value="${v}" ${x.target===v?"selected":""}>${t}</option>`).join("");}
  function card(x){
    const [w,h]=dims(x),synthetic=x.material==="synthetic";
    return `<article class="cpc__page ${x.selected?"is-selected":""}" data-id="${x.id}">
      <div class="cpc__preview">
      <button type="button" class="cpc__preview-button" data-preview>
        <img src="${x.thumb}" alt="Vorschau">
        <span class="cpc__magnifier">⌕</span>
      </button>
    </div>
      <div><div class="cpc__page-head">
        <div>
          <div class="cpc__file">${esc(x.file)} · Seite ${x.page}</div>
          <div class="cpc__meta">Original: ${x.originalFormat==="CUSTOM"?"Sonderformat":"DIN "+x.originalFormat}${x.originalFormat!=="CUSTOM"?` <span class="cpc__format-badge">✓ Originalgröße DIN ${x.originalFormat}</span>`:""} · ${x.ow} × ${x.oh} mm</div>
          <div class="cpc__meta">Ausgabe: ${round(w,1)} × ${round(h,1)} mm</div>
        </div>
        <div class="cpc__page-actions">
          <button type="button" class="cpc__select-inline ${x.selected?"is-selected":""}" data-select>
            <span class="cpc__select-box" aria-hidden="true">${x.selected?"✓":""}</span>
            <span>Für Sammeländerung auswählen</span>
          </button>
          <div class="cpc__price">${euro(itemTotal(x))}</div>
        </div>
      </div>
      <div class="cpc__grid">
        <div class="cpc__field cpc__field--format"><label>Ausgabeformat</label><select data-field="target">${targetOptions(x)}</select></div>
        <div class="cpc__field cpc__field--material"><label class="cpc__label-with-info">Papiersorte <button type="button" class="cpc__info-button" data-material-info>?</button></label><select data-field="material"><option value="paper90" ${x.material==="paper90"?"selected":""}>Plotterpapier 90 g/m²</option><option value="synthetic" ${x.material==="synthetic"?"selected":""}>Synthetisches Papier 130 g/m²</option></select></div>
        <div class="cpc__field cpc__field--finish"><label>Endverarbeitung</label><select data-field="finish" ${synthetic?"disabled":""}><option value="rolled" ${x.finish==="rolled"?"selected":""}>Gerollt</option><option value="folded" ${x.finish==="folded"?"selected":""}>Auf DIN A4 gefaltet</option></select></div>
        <div class="cpc__field cpc__field--lochen"><label>Lochen</label><select data-field="punch" ${synthetic?"disabled":""}><option value="false" ${!x.punch?"selected":""}>Nicht lochen</option><option value="true" ${x.punch?"selected":""}>Lochen (+ 0,20 € pro Blatt)</option></select></div>
        <div class="cpc__field cpc__field--qty"><label>Anzahl</label><input type="number" min="1" max="999" value="${x.qty}" data-field="qty"></div><div class="cpc__field cpc__field--delete"><label>&nbsp;</label><button type="button" class="cpc__delete-button" data-delete>Seite löschen</button></div>
        <div class="cpc__custom ${x.target==="CUSTOM"?"is-visible":""}"><div class="cpc__size-note">Mindestformat: DIN A4. Maximale Druckgröße: 914 × 3.200 mm, unabhängig von der Ausrichtung.</div><div class="cpc__field"><label>Breite in mm</label><input type="number" min="1" max="3200" step=".1" value="${x.cw}" data-field="cw"></div><div class="cpc__field"><label>Höhe in mm</label><input type="number" min="1" max="3200" step=".1" value="${x.ch}" data-field="ch"></div><div class="cpc__field"><label>Maßstab in %</label><input type="number" min="1" step=".1" value="${round(x.cw/x.ow*100,1)}" data-field="scale"></div><div class="cpc__field"><label>Proportionen</label><div class="cpc__proportion-lock">✓ Immer beibehalten</div></div></div>
      </div></div></article>`;
  }

  function render(){
    el.pages.innerHTML=items.length?items.map(card).join(""):'<div class="cpc__empty">Noch keine PDF-Seiten vorhanden.</div>';
    qa("[data-id]").forEach(node=>{
      const x=items.find(i=>i.id===node.dataset.id);
      node.querySelector("[data-select]").addEventListener("click",()=>{x.selected=!x.selected;render();});
      node.querySelector("[data-preview]").addEventListener("click",()=>openModal(items.indexOf(x)));
      node.querySelector("[data-delete]").addEventListener("click",()=>{items=items.filter(i=>i.id!==x.id);render();status("Seite wurde entfernt.","success");});
      node.querySelectorAll("[data-field]").forEach(control=>control.addEventListener("change",()=>update(x,control)));
    });
    renderSummary();
  }

  function update(x,c){
    const f=c.dataset.field,v=c.type==="checkbox"?c.checked:c.value;
    if(f==="material"){x.material=v;if(v==="synthetic"){x.finish="rolled";x.punch=false;}}
    else if(f==="target"){x.target=v;if(v!=="CUSTOM"){const[d1,d2]=dims(x);x.cw=d1;x.ch=d2;}else{const result=boundedProportionalSize(x,Math.min(x.cw/x.ow,x.ch/x.oh));x.cw=result[0];x.ch=result[1];}}
    else if(f==="qty")x.qty=Math.max(1,parseInt(v||1,10));
    else if(f==="punch")x.punch=v==="true";
    else if(f==="cw"){
      const requested=Math.max(.1,Number(v)||1);
      const scale=requested/x.ow;
      const result=boundedProportionalSize(x,scale);
      x.cw=result[0];x.ch=result[1];
      if(scale>result[2])status("Maximale Druckgröße erreicht. Die Proportionen bleiben erhalten.","success");
      if(scale>result[2])status("Maximale Druckgröße erreicht. Die Proportionen bleiben erhalten.","success");
    }
    else if(f==="ch"){
      const requested=Math.max(.1,Number(v)||1);
      const scale=requested/x.oh;
      const result=boundedProportionalSize(x,scale);
      x.cw=result[0];x.ch=result[1];
    }
    else if(f==="scale"){
      const requested=Math.max(.1,Number(v)||100)/100;
      x.target="CUSTOM";
      const result=boundedProportionalSize(x,requested);
      x.cw=result[0];x.ch=result[1];
      if(requested>result[2])status("Maximale Druckgröße erreicht. Die Proportionen bleiben erhalten.","success");
    }
    else if(f!=="keep") x[f]=v;
    render();
  }

  function renderSummary(){
    const t=orderTotals();
    const next=nextDiscountFor(t.subtotal);
    let hint="";
    if(next){
      hint=`Noch ${euro(round(next.min-t.subtotal,2))} bis ${Math.round(next.rate*100)} % Mengenrabatt.`;
    }else{
      hint="Sie erhalten bereits unseren höchsten Mengenrabatt von 20 %.";
    }
    el.summary.innerHTML=`<dl>
      <div><dt>Druck</dt><dd>${euro(t.print)}</dd></div>
      <div><dt>Falten</dt><dd>${euro(t.fold)}</dd></div>
      <div><dt>Lochen</dt><dd>${euro(t.punch)}</dd></div>
      <div><dt>Zwischensumme</dt><dd>${euro(t.subtotal)}</dd></div>
      <div class="cpc__discount-row"><dt>Mengenrabatt (${Math.round(t.discountRate*100)} %)</dt><dd>− ${euro(t.discount)}</dd></div>
      <div><dt>Express</dt><dd>${euro(t.express)}</dd></div>
    </dl>
    <div class="cpc__total"><span>Gesamt</span><span>${euro(t.total)}</span></div>
    <div class="cpc__discount-hint">${hint}</div>`;
    el.bottomTotal.textContent=euro(t.total);
    el.totalPages.textContent=items.reduce((s,x)=>s+x.qty,0);

    const expressCard=el.productionCards.find(c=>c.querySelector('input[value="express"]'));
    if(expressCard){
      const fee=expressFeeFor(t.subtotal);
      const feeLabel=expressCard.querySelector("b");
      if(feeLabel)feeLabel.textContent="+ "+euro(fee);
    }
  }

  async function renderModal(x){
    const source=pdfSources.get(x.sourceId);if(!source)return;const bytes=source.bytes;
    if(modalPdf){try{await modalPdf.destroy();}catch(e){}}
    modalPdf=await pdfjsLib.getDocument({data:bytes.slice()}).promise;modalPage=await modalPdf.getPage(x.sourcePage);
    const rect=el.zoomStage.getBoundingClientRect(),vp=modalPage.getViewport({scale:1}),fit=Math.min((rect.width-20)/vp.width,(rect.height-20)/vp.height),dpr=Math.min(devicePixelRatio||1,2),rv=modalPage.getViewport({scale:fit*dpr});
    const ctx=el.modalCanvas.getContext("2d");el.modalCanvas.width=Math.ceil(rv.width);el.modalCanvas.height=Math.ceil(rv.height);el.modalCanvas.style.width=rv.width/dpr+"px";el.modalCanvas.style.height=rv.height/dpr+"px";await modalPage.render({canvasContext:ctx,viewport:rv}).promise;zoom=1;ox=0;oy=0;applyZoom();
  }
  function applyZoom(){el.modalCanvas.style.transform=`translate(${ox}px,${oy}px) scale(${zoom})`;el.zoomLabel.textContent=Math.round(zoom*100)+" %";}
  function setZoom(next,ax,ay){const old=zoom;next=Math.max(.5,Math.min(5,next));const r=el.zoomStage.getBoundingClientRect();ax=ax??r.width/2;ay=ay??r.height/2;ox=ax-(ax-ox)*(next/old);oy=ay-(ay-oy)*(next/old);zoom=next;applyZoom();}
  function openModal(index){if(!items.length)return;modalIndex=(index+items.length)%items.length;const x=items[modalIndex],[w,h]=dims(x);el.modal.classList.add("is-open");document.body.classList.add("cpc-modal-open");el.modalInfo.innerHTML=`<h3>${esc(x.file)}</h3><dl><div><dt>Seite</dt><dd>${x.page}</dd></div><div><dt>Originalmaße</dt><dd>${x.ow} × ${x.oh} mm</dd></div><div><dt>Ausgabegröße</dt><dd>${round(w,1)} × ${round(h,1)} mm</dd></div><div><dt>Material</dt><dd>${x.material==="paper90"?"Plotterpapier 90 g/m²":"Synthetisches Papier 130 g/m²"}</dd></div><div><dt>Preis</dt><dd>${euro(itemTotal(x))}</dd></div></dl>`;requestAnimationFrame(()=>renderModal(x));}
  function closeModal(){el.modal.classList.remove("is-open");document.body.classList.remove("cpc-modal-open");}
  function openMaterial(){el.materialModal.classList.add("is-open");document.body.classList.add("cpc-modal-open");}
  function closeMaterial(){el.materialModal.classList.remove("is-open");document.body.classList.remove("cpc-modal-open");}

  function holidays(y){const e=easter(y),key=d=>d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0"),add=(d,n)=>new Date(d.getFullYear(),d.getMonth(),d.getDate()+n);return new Set([`${y}-01-01`,`${y}-01-06`,key(add(e,-2)),key(add(e,1)),`${y}-05-01`,key(add(e,39)),key(add(e,50)),key(add(e,60)),`${y}-08-15`,`${y}-10-03`,`${y}-11-01`,`${y}-12-25`,`${y}-12-26`]);}
  function easter(y){const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;return new Date(y,month-1,day);}
  function business(d){return d.getDay()!==0&&d.getDay()!==6&&!holidays(d.getFullYear()).has(d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0"));}
  function nextBusiness(d){let x=new Date(d);do{x.setDate(x.getDate()+1);}while(!business(x));return x;}
  function pickup(){const now=new Date(),before=now.getHours()<15||(now.getHours()===15&&now.getMinutes()<=30);el.bottomPickup.textContent=business(now)&&before?"Abholung heute möglich":"Abholung am nächsten Werktag möglich ("+new Intl.DateTimeFormat("de-DE",{weekday:"long",day:"2-digit",month:"2-digit"}).format(nextBusiness(now))+")";}

  el.input.addEventListener("change",e=>loadFiles(e.target.files).catch(err=>{console.error(err);hideProgress();status(err.message||"PDF konnte nicht verarbeitet werden.","error");}));
  ["dragenter","dragover"].forEach(type=>el.drop.addEventListener(type,e=>{e.preventDefault();e.stopPropagation();el.drop.classList.add("is-dragging");}));
  ["dragleave","drop"].forEach(type=>el.drop.addEventListener(type,e=>{e.preventDefault();e.stopPropagation();el.drop.classList.remove("is-dragging");}));
  document.addEventListener("dragover",e=>e.preventDefault());
  document.addEventListener("drop",e=>e.preventDefault());
  el.drop.addEventListener("drop",e=>loadFiles(e.dataTransfer.files).catch(err=>{console.error(err);hideProgress();status(err.message||"PDF konnte nicht verarbeitet werden.","error");}));

  root.addEventListener("click",e=>{if(e.target.closest("[data-material-info]")){e.preventDefault();openMaterial();}});
  el.selectAll.addEventListener("click",()=>{const all=items.length&&items.every(x=>x.selected);items.forEach(x=>x.selected=!all);render();});
  el.copy.addEventListener("click",()=>{const selected=items.filter(x=>x.selected);if(!selected.length){status("Bitte zuerst Seiten auswählen.","error");return;}const s=selected[0];selected.forEach(x=>{x.target=s.target;x.cw=s.cw;x.ch=s.ch;x.keep=true;x.material=s.material;x.finish=s.finish;x.punch=s.punch;x.qty=s.qty;if(x.material==="synthetic"){x.finish="rolled";x.punch=false;}});render();status("Einstellungen wurden übertragen.","success");});
  el.reset.addEventListener("click",()=>{items=[];pdfSources.clear();el.input.value="";render();status("Auswahl wurde zurückgesetzt.");});
  el.production.forEach(r=>r.addEventListener("change",()=>{el.productionCards.forEach(c=>c.classList.toggle("is-selected",c.querySelector("input").checked));renderSummary();}));
  el.cart.addEventListener("click",async()=>{
    if(!items.length){status("Bitte zuerst mindestens eine PDF-Datei hochladen.","error");return;}
    const endpoint=root.dataset.cpcEndpoint||"";
    if(!endpoint){status("Die Copypark-App ist noch nicht verbunden.","error");return;}

    const totals=orderTotals();
    const form=new FormData();
    const uniqueSources=[...new Set(items.map(x=>x.sourceId))];
    uniqueSources.forEach((sourceId,index)=>{
      const source=pdfSources.get(sourceId);
      if(source){
        form.append("files",new Blob([source.bytes],{type:source.type}),source.name||("bauplan-"+(index+1)+".pdf"));
      }
    });
    form.append("configuration",JSON.stringify({
      version:"1.3",
      currency:"EUR",
      pages:compactPages(),
      totals
    }));

    el.cart.classList.add("is-loading");
    status("Temporärer Artikel wird erstellt …");
    try{
      const response=await fetch(endpoint,{method:"POST",body:form,credentials:"same-origin"});
      const data=await response.json().catch(()=>({}));
      if(!response.ok)throw new Error(data.error||"Temporärer Artikel konnte nicht erstellt werden.");

      const cartResponse=await fetch(window.Shopify.routes.root+"cart/add.js",{
        method:"POST",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({
          items:[{
            id:data.variantId,
            quantity:1,
            properties:{
              "Konfiguration":data.configurationCode||"",
              "PDF-Dateien":data.fileSummary||"",
              "Produktionszeit":totals.production==="express"?"Express":"Standard",
              "Mengenrabatt":Math.round(totals.discountRate*100)+" %",
              "_copypark_temp_product_id":data.productId||""
            }
          }]
        })
      });
      if(!cartResponse.ok){
        const cartError=await cartResponse.json().catch(()=>({}));
        throw new Error(cartError.description||"Artikel konnte nicht in den Warenkorb gelegt werden.");
      }
      window.location.href=window.Shopify.routes.root+"cart";
    }catch(error){
      console.error(error);
      status(error.message||"Beim Erstellen des Artikels ist ein Fehler aufgetreten.","error");
    }finally{
      el.cart.classList.remove("is-loading");
    }
  });

  qa("[data-cpc-modal-close]").forEach(x=>x.addEventListener("click",closeModal));qa("[data-cpc-material-close]").forEach(x=>x.addEventListener("click",closeMaterial));
  el.modalPrev.addEventListener("click",()=>openModal(modalIndex-1));el.modalNext.addEventListener("click",()=>openModal(modalIndex+1));
  el.zoomIn.addEventListener("click",()=>setZoom(zoom*1.2));el.zoomOut.addEventListener("click",()=>setZoom(zoom/1.2));el.zoomFit.addEventListener("click",()=>{zoom=1;ox=0;oy=0;applyZoom();});
  el.zoomStage.addEventListener("wheel",e=>{e.preventDefault();const r=el.zoomStage.getBoundingClientRect();setZoom(zoom*(e.deltaY<0?1.12:1/1.12),e.clientX-r.left,e.clientY-r.top);},{passive:false});
  el.zoomStage.addEventListener("mousedown",e=>{dragging=true;dragStart={x:e.clientX,y:e.clientY,ox,oy};el.zoomStage.classList.add("is-dragging");});
  window.addEventListener("mousemove",e=>{if(!dragging)return;ox=dragStart.ox+e.clientX-dragStart.x;oy=dragStart.oy+e.clientY-dragStart.y;applyZoom();});
  window.addEventListener("mouseup",()=>{dragging=false;el.zoomStage.classList.remove("is-dragging");});
  document.addEventListener("keydown",e=>{if(e.key==="Escape"){closeModal();closeMaterial();}if(el.modal.classList.contains("is-open")&&e.key==="ArrowLeft")openModal(modalIndex-1);if(el.modal.classList.contains("is-open")&&e.key==="ArrowRight")openModal(modalIndex+1);});

  pickup();render();
}

if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
})();
